import React, { useState } from "react";

import Styled from "./ProcessCardStyles";

import {
  Chip,
  CollectionAdded,
  ColorSAP,
  FONT_FAMILY,
  AddCollection,
  GoodsReceipt,
} from "../../ontego-ui";

// @otg-one/ui_components/constants
import {
  FUNCTION_TYPE,
  getFunctionTypeBackgroundColor,
  getFunctionTypeLabelColor,
} from "../../Utils/FunctionType";

import TertiaryButton from "../TertiaryButton/TertiaryButton";
import Tooltip from "../Tooltip/Tooltip";
import { useTranslation } from "react-i18next";

export const ProcessCard = (props) => {
  const [isHover, setIsHover] = useState(false);
  const [isAddToCollectionHover, setIsAddToCollectionHover] = useState(false);

  const { t } = useTranslation();

  const {
    id,
    style,
    func = {
      textName: `Wareneingang`,
      type: [FUNCTION_TYPE.MM, FUNCTION_TYPE.WM, FUNCTION_TYPE.EWM],
    },
    icon = <GoodsReceipt />,
    onClick = () => {},
    onAddToCollectionOnClick,
    isAdded,
    textAddedToCollection = "Added to Collection",
    textAddToCollection = "Add to Collection",
    functionDetailOnClick,
  } = props;

  const handleOnMouseOver = () => setIsHover(true);
  const handleOnMouseOut = () => setIsHover(false);

  const handleOnAddToCollectionMouseOver = () =>
    setIsAddToCollectionHover(true);
  const handleOnAddToCollectionMouseOut = () =>
    setIsAddToCollectionHover(false);

  return (
    <Styled.FunctionBoxContainer
      onMouseEnter={handleOnMouseOver}
      onMouseLeave={handleOnMouseOut}
      onClick={onClick}
      style={style}
      id={id}
      isHover={isHover}
    >
      <div style={{ display: "flex", alignItems: "center", marginBottom: 24 }}>
        <Styled.FunctionBoxIconLabel isHover={isHover}>
          {icon}
        </Styled.FunctionBoxIconLabel>
        <Styled.FunctionBoxTypography
          fontFamily={FONT_FAMILY.PLUS_JAKARTA_SANS_BOLD}
          size={18}
          color={isHover ? ColorSAP.neutral[0] : ColorSAP.neutral[100]}
          onClick={onClick}
        >
          {func.textName}
        </Styled.FunctionBoxTypography>
      </div>

      {isHover && (
        <TertiaryButton
          size="small"
          theme="dark"
          style={{ position: "absolute", bottom: 12, right: 12 }}
          onClick={functionDetailOnClick}
        >
          {t("functionDetails.functionDetail")}
        </TertiaryButton>
      )}

      <Styled.FunctionBoxChipContainer style={{ opacity: isHover ? 0 : 1 }}>
        {func.type.includes(FUNCTION_TYPE.MM) && (
          <Chip
            backgroundColor={getFunctionTypeBackgroundColor(FUNCTION_TYPE.MM)}
            color={getFunctionTypeLabelColor(FUNCTION_TYPE.MM)}
            fontFamily={FONT_FAMILY.PLUS_JAKARTA_SANS_MEDIUM}
          >
            {FUNCTION_TYPE.MM}
          </Chip>
        )}
        {func.type.includes(FUNCTION_TYPE.SD) && (
          <Chip
            backgroundColor={getFunctionTypeBackgroundColor(FUNCTION_TYPE.SD)}
            color={getFunctionTypeLabelColor(FUNCTION_TYPE.SD)}
            style={{ marginLeft: func.type[0] !== FUNCTION_TYPE.SD && 8 }}
            fontFamily={FONT_FAMILY.PLUS_JAKARTA_SANS_MEDIUM}
          >
            {FUNCTION_TYPE.SD}
          </Chip>
        )}
        {func.type.includes(FUNCTION_TYPE.PP) && (
          <Chip
            backgroundColor={getFunctionTypeBackgroundColor(FUNCTION_TYPE.PP)}
            color={getFunctionTypeLabelColor(FUNCTION_TYPE.PP)}
            style={{ marginLeft: func.type[0] !== FUNCTION_TYPE.PP && 8 }}
            fontFamily={FONT_FAMILY.PLUS_JAKARTA_SANS_MEDIUM}
          >
            {FUNCTION_TYPE.PP}
          </Chip>
        )}
        {func.type.includes(FUNCTION_TYPE.WM) && (
          <Chip
            backgroundColor={getFunctionTypeBackgroundColor(FUNCTION_TYPE.WM)}
            color={getFunctionTypeLabelColor(FUNCTION_TYPE.WM)}
            style={{ marginLeft: func.type[0] !== FUNCTION_TYPE.WM && 8 }}
            fontFamily={FONT_FAMILY.PLUS_JAKARTA_SANS_MEDIUM}
          >
            {FUNCTION_TYPE.WM}
          </Chip>
        )}
        {func.type.includes(FUNCTION_TYPE.EAM) && (
          <Chip
            backgroundColor={getFunctionTypeBackgroundColor(FUNCTION_TYPE.EAM)}
            color={getFunctionTypeLabelColor(FUNCTION_TYPE.EAM)}
            style={{ marginLeft: func.type[0] !== FUNCTION_TYPE.EAM && 8 }}
            fontFamily={FONT_FAMILY.PLUS_JAKARTA_SANS_MEDIUM}
          >
            {FUNCTION_TYPE.EAM}
          </Chip>
        )}
        {func.type.includes(FUNCTION_TYPE.EWM) && (
          <Chip
            backgroundColor={getFunctionTypeBackgroundColor(FUNCTION_TYPE.EWM)}
            color={getFunctionTypeLabelColor(FUNCTION_TYPE.EWM)}
            style={{ marginLeft: func.type[0] !== FUNCTION_TYPE.EWM && 8 }}
            fontFamily={FONT_FAMILY.PLUS_JAKARTA_SANS_MEDIUM}
          >
            {FUNCTION_TYPE.EWM}
          </Chip>
        )}
        {func.type.includes(FUNCTION_TYPE.QM) && (
          <Chip
            backgroundColor={getFunctionTypeBackgroundColor(FUNCTION_TYPE.QM)}
            color={getFunctionTypeLabelColor(FUNCTION_TYPE.QM)}
            style={{ marginLeft: func.type[0] !== FUNCTION_TYPE.QM && 8 }}
            fontFamily={FONT_FAMILY.PLUS_JAKARTA_SANS_MEDIUM}
          >
            {FUNCTION_TYPE.QM}
          </Chip>
        )}
        {func.type.includes(FUNCTION_TYPE.PM) && (
          <Chip
            backgroundColor={getFunctionTypeBackgroundColor(FUNCTION_TYPE.PM)}
            color={getFunctionTypeLabelColor(FUNCTION_TYPE.PM)}
            style={{ marginLeft: func.type[0] !== FUNCTION_TYPE.PM && 8 }}
            fontFamily={FONT_FAMILY.PLUS_JAKARTA_SANS_MEDIUM}
          >
            {FUNCTION_TYPE.PM}
          </Chip>
        )}
      </Styled.FunctionBoxChipContainer>

      {/* Collection icon button - commented out
            <Styled.FunctionBoxCollectionIcon
                isAddToCollectionHover={isAddToCollectionHover}
                isAdded={isAdded}
                onMouseOver={handleOnAddToCollectionMouseOver}
                onMouseOut={handleOnAddToCollectionMouseOut}
                onClick={onAddToCollectionOnClick}
            >
                {isAdded ? (
                    <Tooltip title={textAddedToCollection} placement="right">
                        <div>
                            <CollectionAdded />
                        </div>
                    </Tooltip>

                ) : (
                    <Tooltip title={textAddToCollection} placement="right">
                        <div>
                            <AddCollection />
                        </div>
                    </Tooltip>
                )}
            </Styled.FunctionBoxCollectionIcon>
            */}
    </Styled.FunctionBoxContainer>
  );
};

export default React.memo(ProcessCard);
